import Alert from "@mui/material/Alert";
import CircularProgress from "@mui/material/CircularProgress";
import clsx from "clsx";
import { useState } from "react";
import { useNavigate } from "react-router-dom";

const API_BASE_URL = 'https://api.neontradepro.com';

export default function MessageBox({ ticketId, className, subject, category, priority, theme, disabled = false }: { ticketId?: number, className?: string, subject?: string, category?: string, priority?: string, theme?: string, disabled?: boolean } = {}) {
    const navigate = useNavigate();
    
    const [message, setMessage] = useState<string>('');
    const [mediaFiles, setMediaFiles] = useState<File[]>([]);
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const [error, setError] = useState<string>('');

    const token = localStorage.getItem('token');
    const activeTheme = theme || localStorage.getItem('theme') || 'dark';

    async function handleSendMessage(){
        if (disabled) {
            setError('این تیکت بسته شده و امکان ارسال پیام جدید ندارد.');
            return;
        }
        if (!token) return;
        setIsLoading(true);

        try {
            const formdata = new FormData();
            mediaFiles.forEach(file => {
                formdata.append('media', file);
            });
            formdata.append('message', message);

            if (ticketId === undefined){
                if (subject === undefined || subject.trim() === "") throw new Error('موضوع تیکت الزامی است');
                if (category === undefined) throw new Error('دسته‌بندی تیکت الزامی است');
                if (priority === undefined) throw new Error('اولویت تیکت الزامی است');

                formdata.append('subject', subject);
                formdata.append('category', category);
                formdata.append('priority', priority);

                const response = await fetch(`${API_BASE_URL}/tickets`, {
                    method: 'POST',
                    headers: {
                        'Authorization': `Bearer ${token}`,
                    },
                    body: formdata,
                });

                if (!response.ok) {
                    const errorData = await response.json();
                    throw new Error(errorData.detail || 'خطا در ایجاد تیکت');
                }

                const data = await response.json();
                if (data.id) {
                    navigate(`/dashboard/tickets/${data.id}`, { replace: true });
                } else {
                    throw new Error('تیکت ایجاد نشد');
                }
            }
            else {
                const response = await fetch(`${API_BASE_URL}/tickets/${ticketId}/message`, {
                    method: 'POST',
                    headers: {
                        'Authorization': `Bearer ${token}`,
                    },
                    body: formdata,
                });

                if (!response.ok) {
                    const errorData = await response.json();
                    throw new Error(errorData.detail || 'خطا در ارسال پیام');
                }
                window.location.reload();
            }
            
        } catch (err: any) {
            console.error('Failed to send message:', err);
            setError(err.message);
        }
        finally{
            setIsLoading(false);
        }
    }

    return <div className={clsx("ticket-message-box mt-5 rounded-lg", className)}>
        {error && <Alert severity="error">{error}</Alert>}
        <label className="ticket-field-label block mb-2 text-sm font-medium">
            پیام*
        </label>
        <textarea
            className={clsx(
                "ticket-message-textarea p-2.5 w-full text-sm rounded-lg",
                activeTheme === "dark"? "placeholder-gray-400": "placeholder-gray-500"
            )}
            placeholder="پیام خود را بنویسید..."
            value={message}
            rows={6}
            disabled={disabled}
            onChange={(e) => setMessage(e.target.value)}
        />
        <label className="ticket-field-label block my-2 text-sm font-medium">
            پیوست فایل
        </label>
        <input
            className="ticket-file-input block mt-2 mb-4 w-full lg:w-1/2 text-sm rounded-lg"
            type="file"
            multiple
            disabled={disabled}
            onChange={(e) => {
                const files = Array.from(e.target.files || []);
                setMediaFiles(files);
            }}
        />
        <button
            className="ticket-send-button px-4 py-2 rounded"
            onClick={handleSendMessage}
            disabled={isLoading || disabled}
        >
            ارسال
            {isLoading && <CircularProgress size={24} className="ml-2" />}
        </button>
    </div>
}
